import { useChatStore } from "@/stores/chatStore";

export const PrivacyPolicy: React.FC = () => {
  const { market } = useChatStore();
  
  if (market === null) {
    return null;
  }

  const marketLowerCase = market.toLowerCase();
  const domain = window.location.hostname;
  const termsOfUseUrl = `https://${domain}/${marketLowerCase}/terms-of-use`;
  const privacyPolicyUrl = `https://${domain}/${marketLowerCase}/privacy-policy`;

  return (
    <div className="text-xs text-center text-[#87867F]">
      <span>
        This chat may be stored for quality purposes. By using this chat, you
        agree to our company's{" "}
      </span>
      <a
        href={termsOfUseUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="underline"
      >
        terms of use
      </a>
      <span> and </span>
      <a
        href={privacyPolicyUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="underline"
      >
        privacy policy
      </a>
      <span>.</span>
    </div>
  );
};
